import { ConditionRegistryActor } from './categories/actor/ConditionRegistryActor';
import { ConditionRegistryLogic } from './categories/logic/ConditionRegistryLogic';
import { ConditionRegistryMedia } from './categories/media/ConditionRegistryMedia';
import { ConditionRegistryQuestion } from './categories/question/ConditionRegistryQuestion';
import { ConditionRegistryRuntime } from './categories/runtime/ConditionRegistryRuntime';
import { ConditionRegistryActorType } from './categories/actorType/ConditionRegistryActorType';
import { ConditionRegistryTime } from './categories/time/ConditionRegistryTime';
import { ConditionRegistryAspect } from './categories/aspect/ConditionRegistryAspect';
import { RegistryRoof } from '../RegistryRoof';
import { ConditionRegistryContext } from './categories/context/ConditionRegistryContext';
import { ConditionRegistryQuestionTypes } from './categories/question/ConditionRegistryQuestionTypes';
import { ConditionRegistryString } from './categories/string/ConditionRegistryString';
import { ConditionRegistryAsking } from './categories/asking/ConditionRegistryAsking';
export class ConditionRegistry extends RegistryRoof {
    registryType = 'condition';
    c_m = new ConditionRegistryAsking(this);
    c_r = new ConditionRegistryRuntime(this);
    c_c = new ConditionRegistryContext(this);
    c_ac = new ConditionRegistryActor(this);
    c_as = new ConditionRegistryAspect(this);
    c_q = new ConditionRegistryQuestion(this);
    c_qT = new ConditionRegistryQuestionTypes(this);
    c_at = new ConditionRegistryActorType(this);
    c_l = new ConditionRegistryLogic(this);
    c_t = new ConditionRegistryTime(this);
    c_s = new ConditionRegistryString(this);
    c_me = new ConditionRegistryMedia(this);
    get registry_object() {
        return super.registry_object;
    }
}
